import api from '../../../lib/api';
import type { AiChatSessionDetail, AiChatSessionSummary } from '../shared/chatHistoryTypes';
import { downloadBlobFile, parseContentDispositionFilename } from '../shared/downloadBlobFile';
import type { InvestigatorChatSession, SendInvestigatorMessageResult } from './types';

export async function listInvestigatorSessions(
  searchQuery?: string,
): Promise<AiChatSessionSummary[]> {
  const { data } = await api.get('/platform/ai/investigate/sessions', {
    params: searchQuery?.trim() ? { q: searchQuery.trim() } : undefined,
  });
  return data.data as AiChatSessionSummary[];
}

export async function renameInvestigatorSession(
  sessionId: string,
  title: string,
): Promise<AiChatSessionSummary> {
  const { data } = await api.patch(`/platform/ai/investigate/sessions/${sessionId}`, { title });
  return data.data as AiChatSessionSummary;
}

export async function exportInvestigatorSession(
  sessionId: string,
  format: 'md' | 'txt',
): Promise<void> {
  const response = await api.get(`/platform/ai/investigate/sessions/${sessionId}/export`, {
    params: { format },
    responseType: 'blob',
  });
  const fallback = `conversacion-investigador.${format}`;
  const filename = parseContentDispositionFilename(
    response.headers['content-disposition'] as string | undefined,
    fallback,
  );
  downloadBlobFile(response.data as Blob, filename);
}

export async function getInvestigatorSession(sessionId: string): Promise<AiChatSessionDetail> {
  const { data } = await api.get(`/platform/ai/investigate/sessions/${sessionId}`);
  return data.data as AiChatSessionDetail;
}

export async function deleteInvestigatorSession(sessionId: string): Promise<void> {
  await api.delete(`/platform/ai/investigate/sessions/${sessionId}`);
}

export async function createInvestigatorSession(payload?: {
  routeContext?: string;
}): Promise<InvestigatorChatSession> {
  const { data } = await api.post('/platform/ai/investigate/sessions', payload ?? {});
  return data.data as InvestigatorChatSession;
}

export async function sendInvestigatorMessage(
  sessionId: string,
  text: string,
): Promise<SendInvestigatorMessageResult> {
  const { data } = await api.post(
    `/platform/ai/investigate/sessions/${sessionId}/messages`,
    { text },
    { timeout: 300_000 },
  );
  return data.data as SendInvestigatorMessageResult;
}
